module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), (_vm.curZone) ? _c('div', {
    staticClass: "floor-list"
  }, _vm._l((_vm.curZone.wayItemInfoVOList), function(layer, layerIndex) {
    return _c('div', {
      key: layerIndex,
      staticClass: "floor-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(layer.layerInfo))]), _vm._v(" "), _c('div', {
      staticClass: "floor-product-list"
    }, _vm._l((layer.wayItemVOList), function(product, productIndex) {
      return _c('div', {
        key: productIndex,
        staticClass: "flex flex-center item"
      }, [_c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        attrs: {
          "src": product.mainPicView,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "flex1 fs-28 ml-10 item-info"
      }, [_c('div', {
        staticClass: "color-main"
      }, [_vm._v("货道" + _vm._s(product.wayCode))]), _vm._v(" "), _c('div', {
        staticClass: "color-333 text-el"
      }, [_vm._v(_vm._s(product.productName))]), _vm._v(" "), _c('div', {
        staticClass: "mt-8 color-666"
      }, [_vm._v("\n                            数量：" + _vm._s(product.isWeightCalc == 1 ? (product.stockNum / 1000) + 'kg' : product.stockNum || 0 + '件') + "\n                        ")])]), _vm._v(" "), _c('div', {
        staticClass: "peel-btn",
        on: {
          "click": function($event) {
            return _vm.clearWeight(product)
          }
        }
      }, [_vm._v("去皮")])])
    }), 0)])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.clearWeight()
      }
    }
  }, [_vm._v("全部去皮")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55bd1654","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/equipment/peel.vue
// module id = Of5s
// module chunks = 51